import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import {
  Paper,
  Box,
  Grid,
  Divider,
  Hidden,
  Typography,
} from '@material-ui/core';

import i18n from 'i18next';

import bg from '../assets/login-bg.png';
import logo from '../assets/bv-logo-coloured.svg';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    height: '100%',
    background: `url(${bg})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center center',
    backgroundAttachment: 'fixed',
    backgroundColor: theme.palette.secondary.main,
    [theme.breakpoints.down('xs')]: {
      textAlign: 'center',
    },
  },
  paper: {
    width: 560,
    minHeight: 0,
    background: '#fff',
    padding: theme.spacing(4, 5),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(10),
    },
  },
  logoContainer: {
    textAlign: 'center',
    paddingBottom: 20,
  },
  logo: {
    width: '100%',
    maxWidth: 71,
  },
  gridContainer: {
    height: '100%',
  },
  footer: {
    fontSize: 11,
    lineHeight: '16px',
    color: '#808080',
    padding: theme.spacing(1, 0, 0, 0),
  },
}));

const LoginLayout = (props) => {
  const classes = useStyles();

  return (
    <Box
      className={classes.root}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Paper className={classes.paper}>
        <Grid
          container
          alignItems="stretch"
          direction="row"
          className={classes.gridContainer}
        >
          <Grid item xs={12} md={2} className={classes.logoContainer}>
            <img src={logo} alt="bv logo" className={classes.logo} />
          </Grid>
          <Hidden smDown>
            <Grid item md={1}>
              <Divider orientation="vertical" variant="middle" />
            </Grid>
          </Hidden>
          <Grid item md xs={12}>
            {props.children}
            <footer className={classes.footer}>
              <Typography variant="inherit">
                {i18n.t('layout:login:footer')}
              </Typography>
              {/* <Typography className={classes.links}>
              <Link href="#" onClick={preventDefault}>
                Terms & Conditions
              </Link>
            </Typography> */}
            </footer>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

LoginLayout.propTypes = {
  children: PropTypes.node,
};

export default LoginLayout;



// WEBPACK FOOTER //
// ./src/layouts/Login.js